// Features/api/badDebtSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchMemberBadDebts } from "../api/api";

const badDebtSlice = createSlice({
  name: "badDebt",
  initialState: {
    all: [],        // all debts when no member_id passed
    byMember: {},   // { [member_id]: debts[] }
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMemberBadDebts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMemberBadDebts.fulfilled, (state, action) => {
        const { member_id, debts } = action.payload;

        if (member_id) {
          // case: per-member fetch
          state.byMember[member_id] = debts;
        } else {
          // case: all-debts fetch
          state.all = debts;
        }

        state.loading = false;
      })
      .addCase(fetchMemberBadDebts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default badDebtSlice.reducer;
